define('views/modules/template/edit/calendar/activity/activity-panel',[
    // Libs
    'underscore', 'backbone', 'utils',
    // model
    'models/calendar/item/text-session',
    // Views
    'views/modules/template/edit/calendar/template-calendar-item-panel',
    'views/modules/template/edit/calendar/activity/activity-detail-content',
    'views/modules/calendar/favorite/favorite-content',
], function(
    // Libs
    _, Backbone, U,
    // model
    MTextSession,
    // views
    VTemplateCalendarItemPanel,
    VTemplateActivityDetails,
    VFavoriteContent
) {

    var VTemplateActivityPanel = VTemplateCalendarItemPanel.extend({
        content: {
            details: VTemplateActivityDetails,
            favorite: VFavoriteContent,
        },

        initialize: function(options) {
            VTemplateActivityPanel.__super__.initialize.call(this, options);
            this.model = new MTextSession();
        },

        showFavorite: function() {
            this.showContent('favorite', {
                type: "calendar-activity",
                // uses the dirty model from the item form view.
                model: this.view.details.model
            });
        },

    });

    return VTemplateActivityPanel;
});

